import { useRedux } from '../../../../hooks';
import {
    friendsUserViewLast,
    friendsUserCount,
    friendsUserViewAll,
    friendshipUserDestroy,
    friendshipUserLoadIncoming,
    friendshipUserAccept,
    friendshipUserSend,
    friendshipUserCheck,
} from '../../../../redux/user/friendship/actions';

export default function useFriendship() {
    const { dispatch, appSelector } = useRedux();
    const { canSend, friendshipRelation, error, friendshipStatusChanged, allFriendRequests, apiSuccess, loading, setCanSend, allFriends, friendshipDestroyedSuccess } = appSelector((state) => ({
        apiSuccess: state.Friendship.apiSuccess,
        allFriends: state.Friendship.allFriends,
        loading: state.Friendship.loading,
        friendshipDestroyedSuccess: state.Friendship.friendshipDestroyedSuccess,
        allFriendRequests: state.Friendship.allFriendRequests,
        setCanSend: state.Friendship.setCanSend,
        friendshipStatusChanged: state.Friendship.friendshipStatusChanged,
        error: state.Friendship.error,
        friendshipRelation: state.Friendship.friendshipRelation,
        canSend: state.Friendship.canSend
    }));

    const loadLastFriends = (username: string) => {
        dispatch(friendsUserViewLast(username));
    };

    const loadFriendsCount = (username: string) => {
        dispatch(friendsUserCount(username));
    };

    const loadAllFriends = (username: string) => {
        dispatch(friendsUserViewAll(username));
    };

    const userDestroyFriendship = (friendshipId: string) => {
        dispatch(friendshipUserDestroy(friendshipId));
    };

    const loadAllFriendRequests = () => {
        dispatch(friendshipUserLoadIncoming());
    };

    const userAcceptFriendship = (friendshipId: string) => {
        dispatch(friendshipUserAccept(friendshipId));
    };

    const userAddFriend = (username: string) => {
        dispatch(friendshipUserSend(username));
    };

    const loadCheckFriendship = (username: string) => {
        dispatch(friendshipUserCheck(username));
    };

    return {
        loadLastFriends,
        loadFriendsCount,
        loadAllFriends,
        userDestroyFriendship,
        userAddFriend,
        loadAllFriendRequests,
        userAcceptFriendship,
        loadCheckFriendship,
        loading,
        apiSuccess,
        friendshipDestroyedSuccess,
        allFriends,
        friendshipRelation,
        setCanSend,
        error,
        allFriendRequests,
        friendshipStatusChanged,
    };
}
